import { STORE_PERSON } from 'Constants/stores';
import { inject, observer } from 'mobx-react';
import { useUIStore } from 'Modules/ui/index.store';
import { getIsSmallScreen } from 'Modules/ui/secondaryMenu/utils';
import * as React from 'react';
import { SecondaryMenuOptionButton } from '../SecondaryMenuOptionButton';
import { Styled } from './index.styles';
import { SecondaryMenuProps } from './types';

const SecondaryMenuObserver: React.FC<SecondaryMenuProps> = ({
  person: { personAvaliableFeatures },
  header: { onClick, active } = { onClick: undefined, active: false },
  text,
  options,
}) => {
  const setIsSecondaryMenuOpen = useUIStore(
    (state) => state.setIsSecondaryMenuOpen
  );
  const testid = 'secondarySideBarMenu';

  return (
    <Styled.SecondaryMenuWrapper
      onMouseLeave={() => {
        if (getIsSmallScreen()) {
          setIsSecondaryMenuOpen(false);
        }
      }}
      className="h-full left-0 z-50 lg:relative lg:left-auto"
    >
      <Styled.SecondaryMenuHeader>
        {onClick ? (
          <Styled.Button
            variant="primary"
            testid={`${testid}-buttonSecondaryMenuHeader`}
            content={text}
            {...{ onClick, active }}
          />
        ) : (
          <Styled.Heading variant="h5" noMargin>
            {text}
          </Styled.Heading>
        )}
      </Styled.SecondaryMenuHeader>
      <Styled.SecondaryMenuTabs>
        {options.map(({ to, text, featureSwitch, disabled, badge }) => (
          <SecondaryMenuOptionButton
            key={to}
            {...{ to, text, disabled, testid, badge }}
            {...(featureSwitch && {
              show: personAvaliableFeatures[featureSwitch],
            })}
          />
        ))}
      </Styled.SecondaryMenuTabs>
    </Styled.SecondaryMenuWrapper>
  );
};

export const SecondaryMenu = inject(STORE_PERSON)(
  observer(SecondaryMenuObserver)
);
